import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Divider } from '@blueprintjs/core';
import { doc, onSnapshot, collection, addDoc } from 'firebase/firestore';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import EditIcon from '@mui/icons-material/Edit';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

import { FirebaseContext } from '../firebase/FirebaseContext';
import { Form } from './Form';
import { AccountMenu } from './AccountMenu';
import { Actions } from './Actions';

const getDate = (seconds: number) => {
  var d = new Date(0);
  d.setSeconds(seconds);
  return d.toDateString();
};

export const Waitlist: React.FC<any> = () => {
  const [items, setItems] = useState<any[]>();
  const [selected, setSelected] = useState<any>({});

  const { user, db } = useContext(FirebaseContext);
  useEffect(() => {
    if (!user) {
      return;
    }

    const unsub = onSnapshot(
      doc(db, 'users', user.uid, 'properties', 'default'),
      (doc) => {
        console.log('Current data: ', doc.data());
        if (doc.data()?.waitlist) {
          setItems(doc.data()?.waitlist);
        }
      }
    );

    return () => unsub();
  }, [user]);

  const handleSelectionChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.currentTarget.dataset.id) {
        return;
      }
      const update = { ...selected };
      if (e.target.checked) {
        update[e.currentTarget.dataset.id] = true;
      } else {
        delete update[e.currentTarget.dataset.id];
      }
      setSelected(update);
    },
    [selected]
  );

  const [editState, setEditState] = useState();
  const handleEdit = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if (e.currentTarget.dataset.id) {
        setEditState(items?.find((i) => i.id === e.currentTarget.dataset.id));
        setIsOpen(true);
      }
    },
    [items, setEditState]
  );

  const handleNotify = useCallback(
    async (e: React.MouseEvent<HTMLElement>) => {
      if (e.currentTarget.dataset.id) {
        const item = items?.find((i) => i.id === e.currentTarget.dataset.id);
        if (!item) {
          return;
        }

        const { email, phone, name } = item;

        // Send email/sms
        const msg = collection(db, 'messages');
        await addDoc(msg, {
          to: phone,
          body: `Great news ${name}, we found an availability for your booking. Please navigate to www.myhotel.com to complete your booking.`,
        });

        const emails = collection(db, 'mail');
        await addDoc(emails, {
          to: email,
          message: {
            subject: 'Your booking reservation is available!!',
            text: `Hi ${name},\n\nWe found an availability for your booking. Please navigate to www.myhotel.com to complete your booking.\n\nRezylist team`,
          },
        });
      }
    },
    [items]
  );

  const [isOpen, setIsOpen] = useState(false);

  return (
    <section style={{ padding: '25px' }}>
      <header
        style={{
          background: 'black',
          justifyContent: 'space-between',
          padding: 20,
        }}
      >
        <div
          style={{
            height: 100,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'black',
          }}
        >
          <img src="../../assets/iroquois.svg" height={100} width={100} />
        </div>
        <section>
          <AccountMenu />
        </section>
      </header>
      <Actions
        items={items}
        setItems={setItems}
        selected={selected}
        setSelected={setSelected}
      />
      <Divider />
      <section id="list">
        <table className="bp4-html-table bp4-html-table-striped .modifier">
          <thead>
            <tr>
              <th>{/* Select */}</th>
              <th>{/* Edit */}</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Adults</th>
              <th>Children</th>
              <th>Rooms</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Staff</th>
              <th>Notes</th>
              <th>Alert</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((i: any) => (
              <tr key={i.id}>
                <td>
                  <Checkbox
                    onChange={handleSelectionChanged}
                    inputProps={
                      {
                        'data-id': i.id,
                      } as any // TODO: cleaner way?
                    }
                  />
                </td>
                <td>
                  <Button data-id={i.id} onClick={handleEdit}>
                    <EditIcon />
                  </Button>
                </td>
                <td>{i.name}</td>
                <td>{i.phone}</td>
                <td>{i.email}</td>
                <td>{i.adults}</td>
                <td>{i.children}</td>
                <td>{i.rooms}</td>
                <td>{getDate(i.checkin.seconds)}</td>
                <td>{getDate(i.checkout.seconds)}</td>
                <td>{i.staff}</td>
                <td>{i.notes}</td>
                <td>
                  <Button data-id={i.id} onClick={handleNotify}>
                    <NotificationsActiveIcon />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
          {items?.length ? (
            <tfoot>
              <tr>
                <td>Total</td>
                <td>{items?.length}</td>
              </tr>
            </tfoot>
          ) : null}
        </table>
      </section>
      {isOpen && (
        <Form isOpen={isOpen} setIsOpen={setIsOpen} values={editState} />
      )}
    </section>
  );
};
